"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _TopicReplyCount = require("@insided/destination/uikit/TopicReplyCount");

var _Content = require("@insided/destination/modules/Content");

var _classnames = _interopRequireDefault(require("classnames"));

var _UserContext = require("@insided/shared/services/UserContext");

var _contentType = require("@insided/shared/utils/contentType");

var _index = require("./index.sync");

function getTopicAuthor(topic) {
  if ('author' in topic) {
    return topic.author;
  }

  if ('post' in topic) {
    return topic.post.author;
  }

  return undefined;
} // Remove the getTopicIcon function as it's now handled by ContentTypeIcon


function renderVoteButton(topic, voteHandler, index, user) {
  var _ref3;

  var actualContentType = topic.contentType; // If actual contentType is not idea (conversation/discussion), use likes instead of votes

  if (actualContentType !== _contentType.CONTENT_TYPE_IDEA) {
    var _ref = topic,
        hasCurrentUserLiked = _ref.hasCurrentUserLiked,
        likes = _ref.likes;

    var _hasVoted = hasCurrentUserLiked !== null && hasCurrentUserLiked !== void 0 ? hasCurrentUserLiked : false;

    return (0, _preact.h)(_TopicVoteCount.FeaturedTopicVoteButton, {
      hasVoted: _hasVoted,
      votes: likes !== null && likes !== void 0 ? likes : 0,
      onClick: function onClick() {
        voteHandler(index, _hasVoted);
      }
    });
  }

  var _ref2 = topic,
      hasCurrentUserVoted = _ref2.hasCurrentUserVoted,
      voteCount = _ref2.voteCount,
      votes = _ref2.votes;
  var hasVoted = hasCurrentUserVoted !== null && hasCurrentUserVoted !== void 0 ? hasCurrentUserVoted : user.id && votes.includes("".concat(user.id));
  return (0, _preact.h)(_TopicVoteCount.FeaturedTopicVoteButton, {
    hasVoted: hasVoted,
    votes: (_ref3 = voteCount !== null && voteCount !== void 0 ? voteCount : votes.length) !== null && _ref3 !== void 0 ? _ref3 : 0,
    onClick: function onClick() {
      voteHandler(index, hasVoted);
    }
  });
}

var FeaturedListItem = function FeaturedListItem(_ref4) {
  var _topic$label;

  var topic = _ref4.topic,
      voteHandler = _ref4.voteHandler,
      index = _ref4.index,
      user = _ref4.user;
  var author = getTopicAuthor(topic);
  var hasLabel = 'label' in topic && ((_topic$label = topic.label) === null || _topic$label === void 0 ? void 0 : _topic$label.length) > 0;
  var hasReplies = ('replyCount' in topic);
  var displayContentType = (0, _index.getDisplayContentType)(topic);
  var isIdea = displayContentType === 'idea';
  var hasBestAnswer = 'hasBestAnswer' in topic && topic.hasBestAnswer;
  var bugStatus = 'bugStatus' in topic && topic.bugStatus;
  return (0, _preact.h)("div", {
    className: "featured-topic__listed-view-item"
  }, author !== undefined && (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar--XS thread-meta-item__icon",
    showRank: true
  }), (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(topic.url),
    className: "featured-topic__listed-view-url-link",
    title: topic.title,
    "aria-label": topic.title
  }, (0, _preact.h)("div", {
    className: "featured-topic__listed-view-url-link-text"
  }, topic.title), !isIdea && (0, _preact.h)("div", {
    className: "featured-topic__listed-view-item-icon"
  }, (0, _preact.h)(_Content.ContentTypeIcon, {
    contentType: displayContentType,
    hasBestAnswer: hasBestAnswer
  })), topic.contentType === 'idea' && (topic === null || topic === void 0 ? void 0 : topic.ideationStatus) && (0, _preact.h)(_Content.IdeationStatusView, {
    ideationStatus: topic.ideationStatus
  }), bugStatus && (0, _preact.h)(_Content.BugStatusView, {
    bugStatus: bugStatus
  }), hasLabel && (0, _preact.h)("span", {
    className: (0, _classnames.default)('topic__content-type-pill', 'pill', 'pill--uppercase', 'pill--article', 'qa-content-type-pill')
  }, topic.label)), (0, _preact.h)("div", {
    className: "featured-topic__listed-view-item-actions"
  }, hasReplies && !isIdea && (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
    replyCount: topic.replyCount
  }), isIdea && renderVoteButton(topic, voteHandler, index, user)));
};

var FeaturedList = function FeaturedList(_ref5) {
  var featuredTopics = _ref5.featuredTopics,
      showMoreText = _ref5.showMoreText,
      showMoreUrl = _ref5.showMoreUrl,
      voteHandler = _ref5.voteHandler,
      user = _ref5.user;
  var hasShowMore = showMoreText !== undefined && Boolean(showMoreUrl === null || showMoreUrl === void 0 ? void 0 : showMoreUrl.length);
  return (0, _preact.h)("div", {
    className: "featured-topic__listed-view"
  }, (0, _preact.h)("div", {
    className: "featured-topic__listed-view-content"
  }, featuredTopics.map(function (featuredTopic, i) {
    return (0, _preact.h)(FeaturedListItem, {
      key: featuredTopic.title.concat(i.toString()),
      topic: featuredTopic,
      index: i,
      voteHandler: voteHandler,
      user: user
    });
  }), hasShowMore && (0, _preact.h)("div", {
    className: "featured-topic__listed-view-item"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(showMoreUrl)
  }, showMoreText))));
};

var _default = (0, _UserContext.withUserContext)(FeaturedList);

exports.default = _default;